module.exports = __webpack_public_path__ + "static/SpecialElite-Regular-7059acee3b9d8ea9744c26ab45135a8b.ttf";